import React from "react";

const SelectItems = () => {
  return (
    <div className="row text-center justify-content-center text-success">
      <img src="images/choose.png" height="100" style={{width:"100px"}}/>
      <p className="col-md-12 h1">Choose an Item...</p>
    </div>
  );
};

export default SelectItems;
